/*
 * @Description:
 * @Date: 2022-04-11 20:43:05
 */
import { defineComponent } from 'vue';
import { Image, Loading } from 'vant';
export default defineComponent({
  name: 'xrk-image',
  render() {
    return (
      <Image>
        {{
          loading: () => <Loading type="spinner" size="20" />
        }}
      </Image>
    );
  }
});
